import React from 'react'
import { useSelector } from 'react-redux'
import { useAnalytics } from 'reactfire'
import { useHistory } from 'react-router-dom'

import { Header } from '../Header/Header'

import { ScreenWrap } from 'src/views/Quiz/components/QuestionCards/styled'
import { IQuiz } from 'src/api/quizzes/types'
import { answerQuiz } from 'src/api/quizAnswers/quizAnswers'
import { QuestionAnswerPayload } from 'src/api/quizAnswers/types'
import { iRootState } from 'src/store'
import { InitialQuizAnswersKey } from 'src/constants/localStorageKeys'
import { QuizQuestions } from 'src/components/QuizQuestions/QuizQuestions'
import { analyticsEvents } from 'src/constants/analytics/events'
import { COMPLETE_QUIZ } from 'src/constants/routes'

const stateSelector = (state: iRootState) => ({
  user: state.user.data,
})

interface QuestionCardsProps {
  quiz: IQuiz
}

const WelcomeQuiz: React.FC<QuestionCardsProps> = ({ quiz }) => {
  const { logEvent } = useAnalytics()
  const { push } = useHistory()

  const { user } = useSelector(stateSelector)

  const [progress, setProgress] = React.useState(0)
  const [isSignInOpen, setIsSignInOpen] = React.useState(false)
  const [isWTFOpen, setIsWTFOpen] = React.useState(false)
  const [isWelcomeQuizComplete, setIsWelcomeQuizComplete] = React.useState(
    false
  )

  const handleFinishedQuiz = async (quizAnswers: QuestionAnswerPayload[]) => {
    setIsWelcomeQuizComplete(true)
    if (user) {
      try {
        await answerQuiz(quizAnswers)
        logEvent(analyticsEvents.welcomeQuizFinished)
        push(COMPLETE_QUIZ.replace(':id', String(quiz.id)))
      } catch (e) {
        console.error(e)
      }
      return
    }
    localStorage.setItem(InitialQuizAnswersKey, JSON.stringify(quizAnswers))
    setIsSignInOpen(true)
  }

  React.useEffect(() => {
    logEvent(analyticsEvents.welcomeQuizStarted)
  }, [logEvent])

  return (
    <ScreenWrap
      bgStart={quiz.questions[0].colors.bgStart}
      bgEnd={quiz.questions[0].colors.bgEnd}
    >
      <Header
        progress={progress}
        quizTitle={quiz.title}
        isSignInOpen={isSignInOpen}
        setIsSignInOpen={setIsSignInOpen}
        isSignInCloseAllowed={!isWelcomeQuizComplete}
        isWTFOpen={isWTFOpen}
        setIsWTFOpen={setIsWTFOpen}
      />
      <QuizQuestions
        quiz={quiz}
        setProgress={setProgress}
        handleFinishedQuiz={handleFinishedQuiz}
        disableAnswering={isSignInOpen || isWTFOpen}
      />
    </ScreenWrap>
  )
}

export default WelcomeQuiz
